import { useState } from 'react';
import axios from "axios";
import { getSession } from "../utils/session";
import { API_URL } from "../services/api";

export default function ExerciseForm({ onSaved, onClose }) {
  const [name, setName] = useState('');
  const [caloriesBurned, setCaloriesBurned] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { token } = await getSession();
      await axios.post(
        `${API_URL}/exercises`,
        {
          name,
          caloriesBurned: Number(caloriesBurned),
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setName('');
      setCaloriesBurned('');
      setLoading(false);
      if (onSaved) onSaved();
      if (onClose) onClose();
    } catch (err) {
      setLoading(false);
      const msg = err?.response?.data?.message || err?.message || 'Error al registrar ejercicio';
      setError(msg);
      console.error('Error guardando ejercicio:', err);
      alert(msg);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="exercise-form">
      <h2>Registrar ejercicio</h2>
      <div className="form-group">
        <label>Nombre del ejercicio</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </div>
      <div className="form-group">
        <label>Calorías quemadas (kcal)</label>
        <input
          type="number"
          value={caloriesBurned}
          onChange={(e) => setCaloriesBurned(e.target.value)}
          required
        />
      </div>
      {error && <div className="form-error">{error}</div>}
      <button type="submit" className="submit-button" disabled={loading}>
        {loading ? 'Guardando...' : 'Guardar'}
      </button>
    </form>
  );
}
